// src/components/VideoPlayer.js - SO R2 SUPPORT
import React from 'react';
import { Box, Paper, Typography, CircularProgress, Alert, useTheme } from '@mui/material';

const VideoPlayer = ({ video }) => {
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState('');
    const theme = useTheme();

    const getVideoSource = () => {
        if (video?.url && video.url.startsWith('https://')) return video.url;
        if (video?.filePath && video.filePath.startsWith('https://')) return video.filePath;
        if (video?.url && (video.url.includes('youtube.com') || video.url.includes('youtu.be'))) return video.url;
        if (video?.id) return `${process.env.REACT_APP_API_URL}/videos/file/${video.id}`;
        return null;
    };

    const videoSource = getVideoSource();
    const isYoutube = videoSource && (videoSource.includes('youtube.com') || videoSource.includes('youtu.be'));
    const isR2 = videoSource && videoSource.startsWith('https://');

    return (
        <Box sx={{ width: '100%' }}>
            <Typography variant="h5" gutterBottom sx={{
                color: '#ff7eb9', textAlign: 'center', fontWeight: 'bold',
                p: 2, borderBottom: `1px solid ${theme.palette.divider}`
            }}>
                {video?.title || 'Видео'}
            </Typography>

            <Box sx={{
                width: '100%',
                height: { xs: 280, sm: 380, md: 480 },
                backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : '#f0f0f0',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        backgroundColor: theme.palette.mode === 'dark' ? '#1a1a1a' : '#f0f0f0',
                        zIndex: 1
                    }}>
                        <CircularProgress sx={{ color: '#ff7eb9' }} />
                        <Typography sx={{ color: '#ff7eb9', ml: 2 }}>Вчитување...</Typography>
                    </Box>
                )}

                {error && !loading && (
                    <Box sx={{
                        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                        <Alert severity="error" sx={{ width: '80%' }}>{error}</Alert>
                    </Box>
                )}

                {videoSource ? (
                    isYoutube ? (
                        <iframe
                            width="100%" height="100%"
                            src={videoSource.replace('watch?v=', 'embed/')}
                            title={video?.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => setLoading(false)}
                            style={{ display: loading ? 'none' : 'block' }}
                        />
                    ) : (
                        <video
                            controls autoPlay
                            style={{ width: '100%', height: '100%', display: loading ? 'none' : 'block' }}
                            onLoadedData={() => setLoading(false)}
                            onError={() => { setLoading(false); setError('Грешка при вчитување на видеото'); }}
                            preload="metadata"
                        >
                            <source src={videoSource} type="video/mp4" />
                            <source src={videoSource} type="video/webm" />
                            Вашиот прелистувач не поддржува видео елемент.
                        </video>
                    )
                ) : (
                    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                        <Alert severity="warning">Видеото не е достапно</Alert>
                    </Box>
                )}
            </Box>

            {video?.description && (
                <Typography variant="body1" sx={{
                    color: theme.palette.text.secondary, p: 2,
                    borderTop: `1px solid ${theme.palette.divider}`
                }}>
                    {video.description}
                </Typography>
            )}

            <Box sx={{
                display: 'flex', justifyContent: 'space-between',
                alignItems: 'center', px: 2, py: 1,
                borderTop: `1px solid ${theme.palette.divider}`
            }}>
                <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                    {isR2 ? '☁️ Cloud Видео' : isYoutube ? '▶️ YouTube' : '📹 Локално'}
                </Typography>
                {video?.fileName && (
                    <Typography variant="caption" sx={{ color: theme.palette.text.disabled }}>
                        {video.fileName}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default VideoPlayer;